import apiService from "./apiService";
import AppConstants from "../appConstants";

class InstitutionService {
    getAllInstitution(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_INSTITUTION, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getInstitutionDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_INSTITUTION}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerInstitution(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_INSTITUTION, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteInstitution(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_INSTITUTION}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_INSTITUTION_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new InstitutionService();
